import { useEffect } from 'react';

export const useFilteredCategories = (
  categories,
  allPositive,
  allNegative,
  entryType,
  formData,
  setFormData
) => {
  // Filtrar categorias baseado no tipo das transações
  const filteredCategories = categories.filter((category) => {
    if (!category || typeof category !== 'object') return false;

    // Se for transferência, não filtrar categorias (podem ser usadas qualquer uma)
    if (entryType === 'transfer') {
      return true;
    }

    if (allPositive) {
      // Todas entrada: mostrar apenas categorias de entrada (isInput = true)
      return category.isInput === true;
    } else if (allNegative) {
      // Todas saída: mostrar apenas categorias de saída (isInput = false)
      return category.isInput === false;
    } else {
      // Transações mistas: mostrar todas as categorias
      return true;
    }
  });

  // Limpar categoria selecionada quando o tipo das transações muda e fica incompatível
  useEffect(() => {
    if (formData.categoryId && entryType !== 'transfer') {
      const selectedCategory = categories.find((cat) => cat.id === formData.categoryId);
      if (selectedCategory) {
        // Só limpar quando TODAS as transações são do mesmo tipo e a categoria é incompatível
        // Para transações mistas, qualquer categoria é válida — não limpar
        const isIncompatible =
          (allPositive && !selectedCategory.isInput) ||
          (allNegative && selectedCategory.isInput);
        if (isIncompatible) {
          setFormData((prev) => ({
            ...prev,
            categoryId: '',
          }));
        }
      }
    }
  }, [allPositive, allNegative, categories, formData.categoryId, entryType, setFormData]);

  return filteredCategories;
};
